export function GoogleCharts ($translate) {
  var GoogleCharts = function() {
    this.options = {
      fontSize: 12,
      height: 400,
      width: '100%'
    };
  };

  GoogleCharts.prototype.buildReport = function (columns, rows, config) {

    // Add date column to front of columns array.
    if (config.unshiftDateColumn) {
      columns.unshift({id: 'date', label: $translate.instant('GENERAL_SPACE.FIELD.DATE'), type: 'string'});
    }

    var options = angular.extend({}, this.options, config.options)

    var report = {
      data: {
        cols: columns,
        rows: rows
      },
      displayed: false,
      batchOptions: config.batchOptions,
      options: options,
      type: 'ColumnChart',
      view: config.view
    };

    return report;
  };

  GoogleCharts.prototype.buildViewColumns = function (count) {
    var columns = [];

    for (var i=0; i<count; i++) {
      columns.push(i);
    };

    return columns;
  };

  return GoogleCharts;
}